import type { GetServerSidePropsContext, NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';

import { NewsApiService, WebAppApiService } from 'services';
import { INewsDetailsModel, IWebAppModel } from 'models';

import { PagesType } from 'common/pages-type';

import Layout from '@/components/layout/layout';

import styles from './[name].module.scss';
import { useEffect } from 'react';
import { MixpanelTrackingService } from '@/services/mixpanel-services';
import NewsContents from '@/components/news/news-contents';

interface INewsDetailsPageProps {
  webApp: IWebAppModel;
  details: INewsDetailsModel;
  preview: boolean;
}

const NewsDetailsPage: NextPage<INewsDetailsPageProps> = ({
  webApp,
  details,
  preview,
}) => {
  useEffect(() => {
    MixpanelTrackingService.getInstance().pageViewed();
  }, []);

  return (
    <Layout
      preview={preview}
      origin={PagesType.NewsDetails}
      headerImageUrl={webApp.headerImageUrl}
      logoUrl={webApp.logoUrl}
      stravaUrl={webApp.stravaUrl}
      facebookUrl={webApp.facebookUrl}
      instagramUrl={webApp.instagramUrl}
      title={webApp.siteName}
      description={webApp.description}>
      <div className={styles.container}>
        <div className={styles['page']}>
          <div className={styles['bread-crumb']}>
            <Link href="/news">Actualités</Link>&nbsp;/&nbsp;{details.title}{' '}
          </div>
          <div className={styles['content']}>
            <h1>{details.title}</h1>
            <div className={styles['updated-by']}>
              Modifié par {details.createdBy.firstName}{' '}
              {details.createdBy.lastName} le{' '}
              {new Date(details.date).toLocaleDateString()}
            </div>
            <div className={styles['summary']}>{details.summary}</div>
            <NewsContents news={details} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  try {
    const webAppService = new WebAppApiService();
    const webapp = await webAppService.getWebApp(context);

    const { name } = context.query;

    const service = new NewsApiService();
    const details = await service.getNewsDetails(
      context,
      name as string,
      context.preview,
    );

    console.log(details);

    return {
      props: {
        webApp: webapp,
        details: details,
        preview: context.preview ?? false,
      } as INewsDetailsPageProps,
    };
  } catch {
    return {
      props: {},
    };
  }
};

export default NewsDetailsPage;
